import { Button, DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutRevenueDetailQuickInfo extends Layout {
    buttonOpenTariffItem: Button;
    labelChargeAsCalcDescription: Label;
    panelClassicButton: Panel;
    sourceRevenueDetail: DataSource;
}
